import { api } from './api';

export type ServiceStatus = 'ok' | 'degraded' | 'offline';

export interface ServiceHealth {
  status: ServiceStatus;
  last_check: string;
  phone?: string;          // WhatsApp
  message?: string;        // SIGA
  sessions_today?: number; // Agent
}

export interface HealthResponse {
  whatsapp: ServiceHealth;
  siga:     ServiceHealth;
  agent:    ServiceHealth;
}

export const healthService = {
  getHealth: () => api.get<HealthResponse>('/schools/health/'),
};
